import axiosInstance from "./AxiosInstance";

export function getSessionoptionApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/audit/verify-auditor?${fparam}`);
}

export function assetScanApi(data) {
  return axiosInstance.post("api/audit/scan-assets", data);
}

export function verifyAuditSessionApi(sessionId, data) {
  return axiosInstance.post(`api/audit/verify-auditor/${sessionId}`, data);
}

export function endAuditSessionApi(sessionId) {
  return axiosInstance.post(`api/audit/audit-sessions/${sessionId}/end/`);
}

export function getSessionDetailsApi(sessionId, param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(
    `api/audit/audit-sessions-area-list/${sessionId}/?${fparam}`
  );
}

export function getSessionInfoApi(sessionId) {
  return axiosInstance.get(`api/audit/audit-sessions-summary/${sessionId}/`);
}

export function getAreaAuditDetailsApi(sessionId, areaId, param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(
    `api/audit/audit-sessions-area-detail/${sessionId}/${areaId}/?${fparam}`
  );
}

export function getAreaAuditDetailsExportApi(sessionId, areaId, param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(
    `api/audit/audit-sessions-area-detail/${sessionId}/${areaId}/?${fparam}`,
    {
      responseType: "blob",
    }
  );
}
export function mergeScanApi(sessionId){
    return axiosInstance.post(`api/audit/merge-scanned-assets/${sessionId}`)
}
export function getFinalAuditReportApi(sessionid,param){
    const fparam = new URLSearchParams(param).toString();
    return axiosInstance.get(`api/audit/merge-scanned-assets/${sessionid}?${fparam}`)
}
export function getFinalAuditReportExportApi(sessionId,param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(
    `api/audit/merge-scanned-assets/${sessionId}?${fparam}`,
    {
      responseType: "blob",
    }
  );
}
